import React from "react";
import { connect } from "react-redux";

import { isHistoryReady, getAllHistoryItems } from "state/school_money/selectors";
import { fetchHistory } from "state/school_money/actions";

import MaintainValidStudentID from "components/school_money/MaintainValidStudentID";
import Preloader from "components/school_money/Preloader";
import StudentSelector from "components/school_money/StudentSelector";
import StudentCarousel from "components/school_money/StudentCarousel";
import HistoryCard from "components/school_money/history/HistoryCard";

import "./HistoryPage.css";

const cards = [
  { type: "payment", title: "Transaction History" },
  { type: "club", title: "Club History" },
  { type: "dinner", title: "Dinner History" },
  { type: "meal", title: "Meal Selections" }
];

// TODO move to appropirate place
function getSortByMethod(historyType) {
  /**
   * Sort by the appropriate date for the history type, negated for desc sort
   *  unless it's default/id, in which case, asc
   */
  switch (historyType) {
    case "payment" : return (historyItem) => -historyItem.get("paidDate");
    case "dinner"  : return (historyItem) => -historyItem.get("startDate");
    case "club"    : return (historyItem) => -historyItem.get("startDate");
    case "meal"    : return (historyItem) => -historyItem.get("date");
    default        : return (historyItem) => historyItem.get("id");
  }
}

// TODO move to appropirate place
/**
 * @returns {Immutable.List}
 */
function getHistoryCardItemList(historyItems, type, studentID) {
      // we sort on a different property for each history type
  const sortByMethod = getSortByMethod(type);
  return historyItems.get(type)
    .filter(historyItem => historyItem.get("studentID") === studentID)
    .sortBy(sortByMethod)
    .valueSeq().toList();
}

class HistoryPage extends React.PureComponent {

  constructor(props) {
    super(props);
    this.state = {
      expandedCardKey: null
    }
  }

  componentDidMount(){
    this.props.fetchHistory();
  }

  generatePath = studentID => {
    return `/school_money/history/${studentID}/`;
  }

  isHistoryReady = state => {
    return isHistoryReady(state, this.props.studentID);
  }

  onCardExpand = (studentID, type) => {
    this.setState({ expandedCardKey: `${studentID}:${type}` });
  }
  onCardCollapse = () => {
    this.setState({ expandedCardKey: null });
  }

  render() {
    const {allHistoryItems} = this.props;
    const { studentID } = this.props.match.params;
    return (
      <MaintainValidStudentID currentStudentID={studentID} generatePath={this.generatePath}>
        <Preloader isPageReady={this.isHistoryReady}>
          <div className="history-page">
            <div className="page-header">
              <h1 className="page-header__title">History</h1>
              <StudentSelector selectedStudentID={studentID} generatePath={this.generatePath} />
            </div>
            <StudentCarousel activeStudentID={studentID} generatePath={this.generatePath}>
              { studentID => (
                <div className="history-card-list" key={studentID}>
                  {
                    cards.map(({ type, title }) => {
                      const historyCardItems = getHistoryCardItemList(allHistoryItems, type, studentID);
                      const key = `${studentID}:${type}`;
                      return <HistoryCard
                        key={key}
                        type={type}
                        title={title}
                        studentID={studentID}
                        expanded={this.state.expandedCardKey === key}
                        onExpand={this.onCardExpand}
                        onCollapse={this.onCardCollapse}
                        historyItems={historyCardItems}
                      />
                    })
                  }
                </div>
              ) }
            </StudentCarousel>
          </div>
        </Preloader>
      </MaintainValidStudentID>
    );
  }

}

export default connect(
  (state, ownProps) => ({
    allHistoryItems: getAllHistoryItems(state),
  }),
  {
    fetchHistory: fetchHistory
  }

)(HistoryPage);



// WEBPACK FOOTER //
// ./src/components/school_money/history/HistoryPage.js